
import { Injectable, Renderer2, DOCUMENT, inject } from '@angular/core';
import { IScript } from '../models/script.model';

@Injectable({
    providedIn: 'root',
})
export class ScriptService {
    private _document = inject<Document>(DOCUMENT);


    loadJs(renderer: Renderer2, js: IScript | IScript[]): void {
        if (Array.isArray(js)) {
            js.forEach((x: IScript) => {
                if (!this.exists(x.id)) this.appendScriptElement(renderer, x);
            });
        } else if (!this.exists(js.id)) {
            this.appendScriptElement(renderer, js);
        }
    }

    private exists(id: string): boolean {
        return this._document.getElementById(id) !== null;
    }

    private createScriptElement(renderer: Renderer2, script: IScript): HTMLElement {
        const el = renderer.createElement('script');
        el.type = 'text/javascript';
        el.src = script.src;
        el.id = script.id;

        return el;
    }

    private appendScriptElement(renderer: Renderer2, script: IScript): void {
        const el = this.createScriptElement(renderer, script);
        renderer.appendChild(this._document.body, el);
    }
}
